import { UseCase } from '@/shared/application/UseCase';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { CoverageResponse, SfApiResponse } from '@hfc/ui-core';

export class CheckCoverageUseCase implements UseCase<[APPLICATION_TYPES, number], SfApiResponse<CoverageResponse>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (params: [APPLICATION_TYPES, number]): Promise<SfApiResponse<CoverageResponse>> {
    const [applicationType, zip_code] = params;

    return await this.repository.checkCoverage(applicationType, zip_code);
  }

}
